import { AudioManager } from '../manager/audio-manager';
import { LocalAudioTrack } from './local-audio-track';

export class LocalScreenAudioTrack extends LocalAudioTrack {
  constructor(am: AudioManager) {
    super(am);
    this._log.id = `s-${this._log.id}`;
    this.isScreen = true;
  }

  addAudioProcessor(screenAudioWorkletNode: AudioNode, mixNode: AudioNode, silentNode: AudioNode) {
    this.pipeline.silentNode.setNode(silentNode);
    this.pipeline.mixNode.setNode(mixNode);
    this.pipeline.aec.setNode(screenAudioWorkletNode);
    this.enableTrackAEC(false);
  }

  removeAudioProcessor(screenAudioWorkletNode?: AudioNode) {
    if (this.pipeline.aec.node === screenAudioWorkletNode) {
      this.pipeline.aec.deleteNode();
      this.pipeline.silentNode.deleteNode();
      this.pipeline.mixNode.deleteNode();
      this.enableTrackAEC(true);
    }
  }
}
